<template>
    <div>
        <alert v-if="alertPayload" :payload="alertPayload"> </alert>
        <b-list-group class="favorites">
            <b-list-group-item button v-show="isLoading" class="text-center">
                <b-spinner small></b-spinner>
            </b-list-group-item>
            <b-list-group-item button
                class="d-flex justify-content-between"
                v-if="isCorrectCount && !isAlreadyAdded && !isLoading"
                @click="add">
                <div class="d-flex flex-wrap symbols" :class="`symbols-${gameName}`">
                    <span class="symbol mr-1 mb-1" v-for="item in selectedItems" :key="item.id">{{ item.symbol }}</span>
                </div>
                <b-button variant="link" :disabled="isAdding">
                    <template v-if="!isAdding">
                        <fa-icon icon="plus"></fa-icon> {{ 'add_favorite' | lang }}
                    </template>
                    <b-spinner small v-else></b-spinner>
                </b-button>
            </b-list-group-item>
            <template v-if="list">
                <b-list-group-item button
                    class="d-flex justify-content-between"
                    v-for="(item, index) in list"
                    :key="index"
                    @click="choose(item)">
                    <div class="d-flex flex-wrap symbols" :class="`symbols-${gameName}`">
                        <span class="symbol mr-1 mb-1" v-for="item in item.symbols" :key="item.id">{{ item.symbol }}</span>
                    </div>
                    <b-button variant="link" :disabled="!!deletingId" @click.stop="remove(item.id)">
                        <b-spinner small v-if="deletingId == item.id"></b-spinner>
                        <fa-icon v-else icon="trash"></fa-icon>
                    </b-button>
                </b-list-group-item>
            </template>
            <span v-if="list && !list.length" class="ml-4">{{ 'no_favorites' | lang }}</span>
        </b-list-group>
    </div>
</template>

<script>
import Axios from "axios";
import { mapState, mapMutations } from 'vuex';
import { difference } from 'lodash';
import { syncFrameHeight } from "@tv/helpers";
import Alert from "@tv/components/partials/Alert";

export default {
    components: { Alert },
    props: ['gameId', 'isActive', 'gamesItems', 'countId', 'isCorrectCount'],

    data() {
        return {
            isLoading: false,
            isAdding: false,
            deletingId: false,
            alertTimeout: null,
            alertPayload: null
        };
    },

    computed: {
        ...mapState(['favorites']),

        gameName() {
            return this.game.name;
        },

        game() {
            return Config.games[this.gameId];
        },

        sorted() {
            return [ ...this.gamesItems ]
                .sort((a, b) => parseInt(a) - parseInt(b))
                .map(id => parseInt(id));
        },

        selectedItems() {
            const items = [];

            for (const id of this.sorted) {
                items.push({
                    id,
                    symbol: this.game.items[id].symbol,
                });
            }

            return items;
        },

        list() {
            return this.favorites[this.gameId];
        },

        isAlreadyAdded() {
            if (this.list) {
                for (const item of this.list) {
                    const ids = item.symbols.map(symbol => symbol.id);
    
                    if (difference(ids, this.sorted).length == 0) {
                        return true;
                    }
                }
            }

            return false;
        },
    },

    methods: {
        ...mapMutations(['updateFavorites']),

        choose(item) {
            const ids = item.symbols.map(item => item.id.toString());
            this.$emit('choose', ids);
        },

        setAlert(res) {
            clearTimeout(this.alertTimeout);

            this.alertPayload = res;

            this.alertTimeout = setTimeout(() => {
                this.alertPayload = null;
                this.$nextTick(() => syncFrameHeight());
            }, 2000);

            this.$nextTick(() => syncFrameHeight());
        },

        async add() {
            this.isAdding = true;

            try {
                const params = {
                    shop_game_id: this.game.shop_game_id,
                    count_id: this.countId,
                    items_ids: this.gamesItems,
                };

                const { data: res } = await Axios.post(Config.route.favorites_add, params);

                if (res.success) {
                    this.fetch();
                } else {
                    this.setAlert(res);
                }

            } catch (err) {
                console.error(err);
            }

            this.isAdding = false;
        },

        async fetch() {
            this.isLoading = true;

            try {
                const params = { shop_game_id: Config.games[this.gameId].shop_game_id };

                const { data: res } = await Axios.get(Config.route.favorites_get, { params });

                if (res.success) {
                    this.updateFavorites({ gameId: this.gameId, list: res.list.reverse() });
                } else {
                    this.setAlert(res);
                }

            } catch (err) {
                console.error(err);
            }

            this.isLoading = false;
        },

        async remove(id) {
            this.deletingId = id;

            try {
                const params = {
                    shop_game_id: Config.games[this.gameId].shop_game_id,
                    favorite_id: id,
                };

                const { data: res } = await Axios.post(Config.route.favorites_remove, params);

                if (res.success) {
                    this.updateFavorites({ gameId: this.gameId, list: this.list.filter(item => item.id != id) });
                } else {
                    this.setAlert(res);
                }

            } catch (err) {
                console.error(err);
            }

            this.deletingId = false;
        },
    },

    watch: {
        gameId() {
            if (this.isActive && !this.list) {
                this.fetch();
            }
        },

        isActive(now) {
            if (now && !this.list) {
                this.fetch();
            }
        },
    },

    updated() {
        this.$nextTick(() => syncFrameHeight());
    },
}
</script>